import 'slick-carousel/slick/slick.min';
import 'jquery-match-height/dist/jquery.matchHeight-min';

export default class WpetSingle {

    constructor() {
        WpetSingle.mobile_map();
        WpetSingle.toggle_title();
        WpetSingle.slick_table();
        WpetSingle.slick_gallery();
        WpetSingle.anchor_navigation();
    }

    static mobile_map() {
        let $trigger = $('[data-trigger="wpet-show-map"]'),
            $close = $('[data-trigger="wpet-close-map"]'),
            $element = $('[data-id="wpet-mobile-map"]');

        $trigger.on('click', function (e) {
            e.preventDefault();
            $element.show();
            window.wpet_map_object.mapObject.resize();
            $(document).trigger('wpet_map_mobile_show');
        });

        $close.on('click', function (e) {
            e.preventDefault();
            $element.hide();
        });
    }

    static toggle_title() {
        let $trigger = $('[data-trigger="wpet-open-strate"]'),
            element = '[data-id="wpet-strate"]';

        $trigger.each(function () {
            $(this).on('click', function () {
                $(this).parents(element).toggleClass('open');
                $(this).toggleClass('open');
            });
        });

    }

    static slick_table() {
        let $slider = $('[data-id="wpet-slick-table"]'),
            $slide = '[data-id="wpet-slick-table-item"]',
            current_slide = 0;

        if ($('.wpetTableContainer--current').length > 0) {
            current_slide = Number($('.wpetTableContainer--current').attr('data-table-index'));
        }

        if ($slider.length > 0) {
            $slider.slick({
                slide: $slide,
                slidesToShow: 1,
                arrows: true,
                dots: false,
                infinite: false,
                initialSlide: current_slide,
            });
        }
    }

    static slick_gallery() {
        // Slick gallery
        const $slider = $('[data-id="wpet-slick-gallery"]');

        if ($slider.length > 0) {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                arrows: true,
                dots: false,
                infinite: true,
                centerMode: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 650,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });
        }
    }

    static anchor_navigation() {
        let $anchor = $('[data-id="wpet-anchor"]'),
            $anchor_item = $('[data-trigger="wpet-anchor-item"]'),
            $element = $('[data-id="wpet-strate"]');
        if ($anchor.length > 0) {
            let shift = 0;
            if (window.matchMedia("(max-width: 650px)").matches) {
                shift = 50;
            }
            WpetSingle.get_id_active($element, $anchor, $anchor_item, shift);
        }
    }

    static get_id_active(parts_item, wrapper_nav, nav_item, shift) {
        shift = (typeof shift !== 'undefined') ? shift : 0;
        let item_offset = {};

        let id_active = '';
        $.each(parts_item, function () {

            item_offset[$(this).attr('id')] = $(this).offset().top;
        });

        $(window).scroll(function () {


            for (let id in item_offset) {

                if (item_offset[id] < (nav_item.find('a[href="#' + id + '"]').offset().top + shift)) {
                    id_active = id;
                }
            }

            if ('' != id_active) {
                if (item_offset[Object.keys(item_offset)[0]] > (nav_item.find('a[href="#' + id_active + '"]').offset().top + shift)) {

                    nav_item.find('a').removeClass('active');

                } else {
                    nav_item.find('a').removeClass('active');
                    nav_item.find('a[href="#' + id_active + '"]').addClass('active');
                }
            }

        });
    }
}
